<template>
  <div>
    <h3>Beta development</h3>
      Simulate two satellites: one is the target,
      with free drift, and the other is the servicer, which will fly
      around it at a given distance to inspect safely.
      <br />
      <br />
    <h3>Mission planning</h3>
      The inspection mission is divide in three part:
      <ul>
        <li>Start from a safe-close orbit and reach a safe-circumnavigation orbit around the target</li>
        <li>Perform inspection of the target during a specified time</li>
        <li>Safely exit from safe-circumnavigation orbit to reach a safe-close orbit</li>
      </ul>
      <v-img
      contain
      :src="require('../../../assets/images/inspection-mission.png')"
      aspect-ratio="2"
    />
    <br />
    <h3>Local orbital frame</h3>
      Here the TNW local orbital frame is recall with:
      <ul>
        <li>X axis: unit vector in the direction of satellite's velocity vector</li>
        <li>Z axis: unit vector in the same direction as the orbit's angular momentum vector, that is, perpendicular to the orbit plane</li>
        <li>Y axis: unit vector chosen so that the (X,Y,Z) trihedral is direct</li>
      </ul>
      <v-img
      contain
      :src="require('../../../assets/images/tooltip-attitude.png')"
      aspect-ratio="3"
    />
    <br />
    <h3>Hypotheses</h3>
    <p>The underlying assumptions for this beta are the following:</p>
      <ul>
        <li>Both satellites are identical</li>
        <li>The same perturbations is applied on leader and follower spacecraft</li>
        <li>The servicer is on a safe-close orbit whereas the target</li>
        <li>The circumnavigation orbit is about at 100m from the target</li>
        <li>The spacecraft have a propulsion system sufficient to easily control the spacecraft trajectory (ie acceleration higher than 1.4e-4 m/s²)</li>
        <li>Spacecraft is on frozen LEO</li>
      </ul>
  </div>
</template>

<script>
export default {
  name: 'tooltipInspectionMission'
}
</script>
